module.exports = __webpack_public_path__ + "static/media/binance.5a972885.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/binance.svg
// module id = 2386
// module chunks = 7